const formatPlatformName = name =>
  name
    .toLowerCase()
    .split('_')
    .join(' - ');

export default formatPlatformName;
